import React, { useEffect, useRef, useState } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { PlayIconCircle } from "components/page-components/Icons/medium"
import { CaretIcon } from "components/page-components/Icons/small"

export const EkaTeaserBox = ({
  auftragnehmerSelected,
  toggleLessons,
  thumbnail,
  lessonsActive,
  reverseBoolean,
  lessonOneTitle,
}) => {
  auftragnehmerSelected = reverseBoolean
    ? !auftragnehmerSelected
    : auftragnehmerSelected

  if (typeof window !== "undefined") {
    window.dataLayer.push({
      event: "give_me_wistia_popover",
      requires_wistia_popover: true,
    })
  }
  const [boxDimensions, setBoxDimensions] = useState({
    width: 577,
    height: 247,
  })
  const boxRef = useRef(null)

  const handleResize = () =>
    setBoxDimensions({
      width: boxRef.current.clientWidth,
      height: boxRef.current.clientHeight,
    })

  useEffect(() => {
    setBoxDimensions({
      width: boxRef.current.clientWidth,
      height: boxRef.current.clientHeight,
    })
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return (
    <React.Fragment>
      <div
        ref={boxRef}
        className="box product-box px-3"
        style={{
          minHeight: 247,
          transition: !auftragnehmerSelected ? ".4s ease " : ".4s ease .4s",
          zIndex: auftragnehmerSelected ? 10 : 0,
          opacity: auftragnehmerSelected ? 1 : 0,
          display: auftragnehmerSelected ? "block" : "hidden",
          transform: auftragnehmerSelected
            ? "translate(0px)"
            : "translate(150px)",
          gridArea: "1/1",
        }}
      >
        <div className="columns ">
          <div
            className="column is-5 has-text-centered"
            onClick={auftragnehmerSelected ? toggleLessons : undefined}
            onKeyDown={() => {}}
            aria-label="lessons toggle"
            role="button"
            tabIndex={-1}
            style={{
              cursor: auftragnehmerSelected ? "pointer" : "auto",
            }}
          >
            <GatsbyImage
              image={thumbnail.childImageSharp.gatsbyImageData}
              alt="Anmeldung zum E-Mail-Kurs"
              title="Anmeldung zum E-Mail-Kurs"
            />
          </div>

          <div className="column is-flex is-flex-direction-column">
            <div className="level is-mobile ">
              <div className="level-left is-hidden-mobile"></div>
              <div
                data-nosnippet
                style={{
                  cursor: auftragnehmerSelected ? "pointer" : "auto",
                }}
                className={`level-right wistia_embed wistia_async_${
                  auftragnehmerSelected ? "xpgqk9h8sh" : "9479hm8hh2"
                } popover=true popoverContent=link`}
              >
                <div className="level-item ">
                  <div className="has-text-mitternachtsblau link mr-2">
                    Video
                  </div>
                  <span className="icon level-item has-text-mitternachtsblau">
                    <PlayIconCircle />
                  </span>
                </div>
              </div>
            </div>
            <div
              onClick={auftragnehmerSelected ? toggleLessons : undefined}
              onKeyDown={() => {}}
              aria-label="lessons toggle"
              role="button"
              tabIndex={-2}
              className="mt-auto"
              style={{
                cursor: auftragnehmerSelected ? "pointer" : "auto",
              }}
            >
              <p className=" subtitle is-6 has-text-mitternachtsblau">
                Lektion 1
              </p>
              <p className="title is-4 has-text-mitternachtsblau">
                {lessonOneTitle}
              </p>
              <p className=" has-text-mitternachtsblau">
                <span
                  style={{
                    textDecoration: "underline",
                    marginRight: "1rem",
                  }}
                >
                  Alle Lektionen
                </span>

                <CaretIcon {...{ rotation: lessonsActive ? "up" : "down" }} />
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        className="box is-hidden-touch"
        style={{
          minHeight: 247,
          height: boxDimensions.height,
          width: boxDimensions.width,
          transition: `transform .4s ${
            !auftragnehmerSelected ? "0s" : ".5s"
          }, opacity .4s ${!auftragnehmerSelected ? "0s" : ".5s"}, top .2s ${
            lessonsActive ? "0s" : ".3s"
          }, right .2s ${lessonsActive ? "0s" : ".3s"}`,
          zIndex: auftragnehmerSelected ? 5 : 0,
          opacity: auftragnehmerSelected ? 1 : 0,
          display: auftragnehmerSelected ? "block" : "hidden",
          transform: auftragnehmerSelected
            ? "translate(0px)"
            : "translate(150px)",
          position: "absolute",
          top: lessonsActive ? 8 : -10,
          right: lessonsActive ? 8 : -10,
        }}
      ></div>
      <div
        className="box is-hidden-touch"
        style={{
          minHeight: 247,
          height: boxDimensions.height,
          width: boxDimensions.width,
          transition: `transform .4s ${
            !auftragnehmerSelected ? "0s" : ".6s"
          }, opacity .4s ${!auftragnehmerSelected ? "0s" : ".6s"}, top .2s ${
            lessonsActive ? "0s" : ".3s"
          }, right .2s ${lessonsActive ? "0s" : ".3s"}`,
          zIndex: auftragnehmerSelected ? 3 : 0,
          opacity: auftragnehmerSelected ? 1 : 0,
          display: auftragnehmerSelected ? "block" : "hidden",
          transform: auftragnehmerSelected
            ? "translate(0px)"
            : "translate(150px)",
          position: "absolute",
          top: lessonsActive ? 4 : -30,
          right: lessonsActive ? 4 : -30,
        }}
      ></div>
    </React.Fragment>
  )
}
